import {GENDER_CODES, GENDER_LABELS, type GenderCode} from '@common/gender';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@common-web/components/ui/select';

/** The options for a person added to a member's record; Other is for VIP and imported records. */
export const MEMBER_GENDER_CODES = ['M', 'F'] as const;

export function GenderSelect({
  className,
  codes = GENDER_CODES,
  disabled,
  id,
  onValueChange,
  placeholder = 'Select gender',
  value,
}: {
  className?: string;
  codes?: readonly GenderCode[];
  disabled?: boolean;
  id?: string;
  onValueChange: (value: GenderCode) => void;
  placeholder?: string;
  value: GenderCode | '';
}) {
  return (
    <Select
      value={value || undefined}
      onValueChange={(next) => onValueChange(next as GenderCode)}
      disabled={disabled}
    >
      <SelectTrigger id={id} className={className}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {codes.map((code) => (
          <SelectItem key={code} value={code}>
            {GENDER_LABELS[code]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
